export default __webpack_public_path__ + "static/media/anisha-matharu-and-sabrina-moin-320.5eda5c92.jpg";